import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import {
  MdVisibility,
  MdVisibilityOff,
  MdPersonOutline,
  MdLockOutline,
  MdLogin,
  MdSupportAgent,
  MdErrorOutline,
} from "react-icons/md";

import {
  HiOutlineShieldCheck,
  HiOutlineOfficeBuilding,
} from "react-icons/hi";

import work from "./assets/wor.jpg";

export default function Login() {
  const API = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();

  // =========================================================
  // STATE
  // =========================================================

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [usernameError, setUsernameError] =
    useState("");

  const [passwordError, setPasswordError] =
    useState("");

  const [loginError, setLoginError] =
    useState("");

  const [showPassword, setShowPassword] =
    useState(false);

  const [loading, setLoading] =
    useState(false);

  // =========================================================
  // LOGIN
  // =========================================================

  const handlelogin = async () => {
    // Reset errors
    setUsernameError("");
    setPasswordError("");
    setLoginError("");

    let hasError = false;

    // -------------------------------------------------------
    // VALIDATION
    // -------------------------------------------------------

    if (!username.trim()) {
      setUsernameError("Username is required");
      hasError = true;
    }

    if (!password.trim()) {
      setPasswordError("Password is required");
      hasError = true;
    }

    if (hasError) {
      return;
    }

    // -------------------------------------------------------
    // API LOGIN
    // -------------------------------------------------------

    try {
      setLoading(true);

      const res = await axios.post(
        `${API}/api/login/`,
        {
          username: username.trim(),
          password,
        }
      );

      console.log("Login response:", res.data);

      // -----------------------------------------------------
      // SAVE AUTH DATA
      // -----------------------------------------------------

      localStorage.setItem(
        "token",
        res.data.access_token
      );

      localStorage.setItem(
        "user_id",
        res.data.user_id
      );

      localStorage.setItem(
        "userrole",
        res.data.role
      );

      localStorage.setItem(
        "username",
        res.data.username
      );

      localStorage.setItem(
        "department_id",
        res.data.department_id
      );

      localStorage.setItem(
        "department_name",
        res.data.department_name
      );

      // -----------------------------------------------------
      // ROLE BASED NAVIGATION
      // -----------------------------------------------------

      if (res.data.role === "client") {
        navigate("/clientdashboard");
        return;
      }

      if (res.data.role === "support") {
        navigate("/supportdashboard");
        return;
      }

      if (res.data.role === "admin") {
        navigate("/supportdashboard");
        return;
      }

      // -----------------------------------------------------
      // INVALID ROLE
      // -----------------------------------------------------

      localStorage.clear();

      setLoginError(
        "Your account does not have access to this application."
      );

    } catch (error) {
      console.error("Login error:", error);

      // -----------------------------------------------------
      // API ERROR
      // -----------------------------------------------------

      if (error.response?.data?.detail) {
        setLoginError(
          error.response.data.detail
        );
      } else if (error.response?.status === 401) {
        setLoginError(
          "Invalid username or password."
        );
      } else {
        setLoginError(
          "Unable to login. Please try again."
        );
      }

    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // ENTER KEY
  // =========================================================

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !loading) {
      handlelogin();
    }
  };

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <div
      className="
        min-h-screen
        bg-slate-50
        flex
        items-center
        justify-center
        p-4
        sm:p-6
      "
    >

      {/* =====================================================
          MAIN LOGIN CARD
      ===================================================== */}

      <div
        className="
          w-full
          max-w-5xl
          bg-white
          rounded-2xl
          shadow-xl
          border
          border-slate-200
          overflow-hidden
          grid
          grid-cols-1
          lg:grid-cols-2
        "
      >

        {/* ===================================================
            LEFT IMAGE / BRANDING
        =================================================== */}

        <div
          className="
            relative
            hidden
            lg:block
            min-h-[620px]
            overflow-hidden
          "
        >

          <img
            src={work}
            alt="Workplace"
            className="
              absolute
              inset-0
              w-full
              h-full
              object-cover
            "
          />

          {/* Overlay */}

          <div
            className="
              absolute
              inset-0
              bg-slate-950/65
            "
          />

          {/* Branding */}

          <div
            className="
              relative
              z-10
              h-full
              flex
              flex-col
              justify-between
              p-8
              xl:p-10
              text-white
            "
          >

            {/* TOP */}

            <div>

              {/* <div
                className="
                  w-11
                  h-11
                  rounded-xl
                  bg-white/15
                  border
                  border-white/20
                  backdrop-blur-sm
                  flex
                  items-center
                  justify-center
                  mb-5
                "
              >
                <HiOutlineShieldCheck
                  size={25}
                />
              </div> */}

              {/* <h1
                className="
                  text-3xl
                  xl:text-4xl
                  font-bold
                  leading-tight
                "
              >
                Issue
                <br />
                Management
              </h1> */}

              {/* <p
                className="
                  mt-4
                  text-sm
                  leading-6
                  text-white/75
                  max-w-sm
                "
              >
                Manage support queries, departments
                and user access from one centralized
                platform.
              </p> */}

            </div>

            {/* FEATURES */}

            <div className="space-y-3">

              <div className="flex items-center gap-3">

                {/* <div
                  className="
                    w-9
                    h-9
                    rounded-lg
                    bg-white/10
                    flex
                    items-center
                    justify-center
                  "
                >
                  <MdSupportAgent
                    size={19}
                  />
                </div> */}

                {/* <div>
                  <p className="text-sm font-semibold">
                    Support Management
                  </p>

                  <p className="text-xs text-white/60">
                    Track and resolve queries
                  </p>
                </div> */}

              </div>

              <div className="flex items-center gap-3">

                {/* <div
                  className="
                    w-9
                    h-9
                    rounded-lg
                    bg-white/10
                    flex
                    items-center
                    justify-center
                  "
                >
                  <HiOutlineOfficeBuilding
                    size={19}
                  />
                </div> */}

                <div>
                  {/* <p className="text-sm font-semibold">
                    Department Access
                  </p> */}

                  {/* <p className="text-xs text-white/60">
                    Department-based workflow
                  </p> */}
                </div>

              </div>

            </div>

            {/* BOTTOM */}

            <p className="text-xs text-white/50">
              Secure access • Internal Management
              System
            </p>

          </div>

        </div>

        {/* ===================================================
            RIGHT LOGIN FORM
        =================================================== */}

        <div
          className="
            flex
            items-center
            justify-center
            p-6
            sm:p-8
            lg:p-10
            xl:p-12
          "
        >

          <div className="w-full max-w-md">

            {/* MOBILE BRAND */}

            <div className="lg:hidden mb-8">

              <div className="flex items-center gap-3">

                <div
                  className="
                    w-10
                    h-10
                    rounded-xl
                    bg-sky-50
                    text-sky-600
                    flex
                    items-center
                    justify-center
                  "
                >
                  <HiOutlineShieldCheck
                    size={23}
                  />
                </div>

                <div>

                  <h1 className="text-xl font-bold text-slate-800">
                    Issue Management
                  </h1>

                  <p className="text-xs text-slate-500">
                    Support Management System
                  </p>

                </div>

              </div>

            </div>

            {/* HEADER */}

            <div className="mb-8">

              <p
                className="
                  text-xs
                  font-semibold
                  uppercase
                  tracking-wider
                  text-sky-600
                  mb-2
                "
              >
                Welcome 
              </p>

              <h2
                className="
                  text-2xl
                  sm:text-3xl
                  font-bold
                  text-slate-800
                "
              >
                Sign in
              </h2>

              <p
                className="
                  mt-2
                  text-sm
                  text-slate-500
                "
              >
                Enter your credentials to access
                your
              </p>

            </div>

            {/* =================================================
                LOGIN ERROR
            ================================================= */}

            {loginError && (

              <div
                className="
                  mb-5
                  flex
                  items-start
                  gap-3
                  p-3
                  rounded-lg
                  border
                  border-red-200
                  bg-red-50
                  text-red-700
                "
              >

                <MdErrorOutline
                  size={19}
                  className="mt-0.5 flex-shrink-0"
                />

                <p className="text-sm">
                  {loginError}
                </p>

              </div>

            )}

            {/* =================================================
                USERNAME
            ================================================= */}

            <div className="mb-5">

              <label
                htmlFor="username"
                className="
                  block
                  text-sm
                  font-semibold
                  text-slate-700
                  mb-2
                "
              >
                Username
              </label>

              <div className="relative">

                <MdPersonOutline
                  size={20}
                  className="
                    absolute
                    left-3
                    top-1/2
                    -translate-y-1/2
                    text-slate-400
                  "
                />

                <input
                  id="username"
                  type="text"
                  value={username}
                  placeholder="Enter your username"
                  autoComplete="username"
                  disabled={loading}
                  onChange={(e) => {
                    setUsername(
                      e.target.value
                    );
                    setUsernameError("");
                    setLoginError("");
                  }}
                  onKeyDown={handleKeyDown}
                  className={`
                    w-full
                    h-11
                    pl-10
                    pr-3
                    rounded-lg
                    border
                    bg-slate-50
                    text-sm
                    text-slate-700
                    placeholder:text-slate-400
                    outline-none
                    transition

                    ${
                      usernameError
                        ? "border-red-300 focus:border-red-400 focus:ring-2 focus:ring-red-100"
                        : "border-slate-200 focus:bg-white focus:border-sky-400 focus:ring-2 focus:ring-sky-100"
                    }

                    disabled:opacity-60
                    disabled:cursor-not-allowed
                  `}
                />

              </div>

              {usernameError && (

                <p
                  className="
                    mt-1.5
                    text-xs
                    font-medium
                    text-red-600
                  "
                >
                  {usernameError}
                </p>

              )}

            </div>

            {/* =================================================
                PASSWORD
            ================================================= */}

            <div className="mb-6">

              <label
                htmlFor="password"
                className="
                  block
                  text-sm
                  font-semibold
                  text-slate-700
                  mb-2
                "
              >
                Password
              </label>

              <div className="relative">

                <MdLockOutline
                  size={20}
                  className="
                    absolute
                    left-3
                    top-1/2
                    -translate-y-1/2
                    text-slate-400
                  "
                />

                <input
                  id="password"
                  type={
                    showPassword
                      ? "text"
                      : "password"
                  }
                  value={password}
                  placeholder="Enter your password"
                  autoComplete="current-password"
                  disabled={loading}
                  onChange={(e) => {
                    setPassword(
                      e.target.value
                    );
                    setPasswordError("");
                    setLoginError("");
                  }}
                  onKeyDown={handleKeyDown}
                  className={`
                    w-full
                    h-11
                    pl-10
                    pr-11
                    rounded-lg
                    border
                    bg-slate-50
                    text-sm
                    text-slate-700
                    placeholder:text-slate-400
                    outline-none
                    transition

                    ${
                      passwordError
                        ? "border-red-300 focus:border-red-400 focus:ring-2 focus:ring-red-100"
                        : "border-slate-200 focus:bg-white focus:border-sky-400 focus:ring-2 focus:ring-sky-100"
                    }

                    disabled:opacity-60
                    disabled:cursor-not-allowed
                  `}
                />

                <button
                  type="button"
                  onClick={() =>
                    setShowPassword(
                      !showPassword
                    )
                  }
                  disabled={loading}
                  className="
                    absolute
                    right-2
                    top-1/2
                    -translate-y-1/2
                    w-8
                    h-8
                    rounded-md
                    flex
                    items-center
                    justify-center
                    text-slate-400
                    hover:bg-slate-200
                    hover:text-slate-600
                    transition
                  "
                  aria-label={
                    showPassword
                      ? "Hide password"
                      : "Show password"
                  }
                >

                  {showPassword ? (
                    <MdVisibilityOff
                      size={19}
                    />
                  ) : (
                    <MdVisibility
                      size={19}
                    />
                  )}

                </button>

              </div>

              {passwordError && (

                <p
                  className="
                    mt-1.5
                    text-xs
                    font-medium
                    text-red-600
                  "
                >
                  {passwordError}
                </p>

              )}

            </div>

            {/* =================================================
                LOGIN BUTTON
            ================================================= */}

            <button
              type="button"
              onClick={handlelogin}
              disabled={loading}
              className="
                w-full
                h-11
                rounded-lg
                bg-sky-600
                hover:bg-sky-700
                active:bg-sky-800
                disabled:bg-slate-300
                disabled:cursor-not-allowed
                text-white
                text-sm
                font-semibold
                flex
                items-center
                justify-center
                gap-2
                shadow-sm
                transition
              "
            >

              {loading ? (

                <>
                  <span
                    className="
                      w-4
                      h-4
                      border-2
                      border-white/40
                      border-t-white
                      rounded-full
                      animate-spin
                    "
                  />

                  Signing in...
                </>

              ) : (

                <>
                  <MdLogin size={19} />

                  Sign In
                </>

              )}

            </button>

            {/* =================================================
                SECURITY NOTE
            ================================================= */}

            <div
              className="
                mt-6
                flex
                items-center
                justify-center
                gap-2
                text-xs
                text-slate-400
              "
            >

              <HiOutlineShieldCheck
                size={15}
              />

              Secure internal system access

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}